
export default class DataSet
{
	id;
	dataTables;
}


// WEBPACK FOOTER //
// ./src/universalView/dataSet/DataSet.js